<template>
  <div class="prontuario-medico-form">
    <modal-data-form
      :show-modal="store.showModalDataForm"
      :title="title"
      :on-save="onSave"
    >
      <field-group-form :group-label="$t('Prontuario')">
        <v-row>
          <v-col class="ma-0 py-0 pt-6" cols="12">
            <validation-provider
              v-slot="{ errors }"
              name="prontuarioMedico"
              rules="size:20480"
            >
              <v-file-input
                v-model="fields.prontuarioMedico"
                chips
                filled
                prepend-icon="mdi-file-upload-outline"
                :error-messages="errors"
                :show-size="true"
                :truncate-length="$vuetify.breakpoint.xsOnly ? 20 : 50"
                :placeholder="$t('click_para_inserir_foto_pdf')"
                accept="image/*, .pdf"
              />
            </validation-provider>
          </v-col>
        </v-row>
      </field-group-form>
      <field-group-form :group-label="$t('Veterinario')">
        <v-row>
          <v-col class="ma-0 py-0 pt-2" cols="12" md="4">
            <v-text-field
              v-model="fields.nomeVeterinario"
              v-mask="{
                mask: [Array(80).fill('X').join('')],
                tokens: { X: { pattern: /[A-zÀ-ú\s\\.]/ } },
                masked: true,
              }"
              outlined
              dense
              background-color="white"
              class="ma-0 pa-0"
              :label="$t('Nome')"
            />
          </v-col>
          <v-col class="ma-0 py-0 pt-2" cols="12" md="4">
            <validation-provider
              v-slot="{ errors }"
              name="foneVeterinario"
              :rules="{ fone: /\(\d\d\)\s\d{4,5}-\d{4}/ }"
            >
              <v-text-field
                v-model="fields.foneVeterinario"
                v-mask="['(##) #####-####', '(##) ####-####']"
                outlined
                dense
                background-color="white"
                class="ma-0 pa-0"
                :label="$t('Telefone')"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col class="ma-0 py-0 pt-2" cols="12" md="4">
            <v-text-field
              v-model="fields.empresaVeterinario"
              v-mask="{
                mask: [Array(80).fill('X').join('')],
                tokens: { X: { pattern: /[A-zÀ-ú\s\\.0-9-]/ } },
                masked: true,
              }"
              outlined
              dense
              background-color="white"
              class="ma-0 pa-0"
              :label="$t('Clinica')"
            />
          </v-col>
          <v-col class="ma-0 py-0 pt-2" cols="12">
            <v-text-field
              v-model="fields.observacao"
              outlined
              dense
              background-color="white"
              class="ma-0 pa-0"
              label="Observação"
            />
          </v-col>
        </v-row>
      </field-group-form>
    </modal-data-form>
  </div>
</template>

<script>
import ModalDataForm from "@/components/forms/modal-data-form";
import FieldGroupForm from "@/components/forms/field-group-form";
import { extend, ValidationProvider } from "vee-validate";
import { size, regex } from "vee-validate/dist/rules";
import { updateData, uploadFile } from "@/services";

export default {
  props: {
    title: {
      type: String,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { FieldGroupForm, ModalDataForm, ValidationProvider },
  data: () => ({
    fields: {
      prontuarioMedico: null,
      nomeVeterinario: "",
      foneVeterinario: "",
      empresaVeterinario: "",
      observacao: "",
    },
  }),
  watch: {
    "store.showModalDataForm"() {
      this.fields = { ...this.fields, ...this.data };
      this.fields.prontuarioMedico = null;
      this.fields.nomeVeterinario = this.$options.filters.toPT_BRCapitalize(
        this.fields.nomeVeterinario
      );
      this.fields.empresaVeterinario = this.$options.filters.toPT_BRCapitalize(
        this.fields.empresaVeterinario
      );
    },
  },
  computed: {
    store() {
      return this.$store.state;
    },
  },
  beforeMount() {
    this.$store.commit("setShowModalDataForm", false);

    extend("size", {
      ...size,
      message: this.$t("arquivo_menos_de_20MB"),
    });

    extend("fone", {
      ...regex,
      message: this.$t("telefone_invalido"),
    });
  },
  methods: {
    onSave() {
      const fields = JSON.parse(JSON.stringify(this.fields));
      if (this.fields.prontuarioMedico) {
        uploadFile(
          this,
          "pet",
          this.fields.prontuarioMedico,
          "prontuarioMedico",
          (data) => {
            updateData(this, "pet", {
              ...fields,
              ...data,
            });
          }
        );
      } else {
        this.fields.prontuarioMedico = this.data.prontuarioMedico;
        updateData(this, "pet", this.fields);
      }
    },
  },
};
</script>

<style scoped></style>
